import React, { FC } from 'react'
import { Trans } from '@lingui/macro'

import { Box, Flex, Link, Switch } from 'front-end/src/components'
import Message, {
  MessageTypes
} from 'front-end/src/components/common/message/Message'

export const UserAccessibility: FC = () => {
  return (
    <div className="User__accessibility">
      <Box as="h3" mb="16px">
        <Trans>High contrast mode</Trans>
      </Box>
      <Flex alignItems="center">
        <Switch isChecked={false} isDisabled />
        <Box ml="8px" cursor="not-allowed">
          <Trans>Make text easier to see by using high contrast colours.</Trans>
        </Box>
      </Flex>
      <Message type={MessageTypes.WARNING} mt="24px">
        <Box>
          <Trans>
            <strong>NOTICE:</strong> This feature is deprecated so we have
            disable this since the contrast is matching the
          </Trans>
          &nbsp;
          <Link href="https://www.w3.org/TR/WCAG21/">
            Accessibility Guidelines WCAG2.1
          </Link>
          .
        </Box>
      </Message>
    </div>
  )
}
